if (!customElements.get('product-media-grid')) {
  class ProductMediaGrid extends HTMLElement {
    constructor() {
      super();

      this.init();
    }

    init() {
      // Set the max amount of rows to show
      this.amountOfPreviewMedia = 6 / 2;
      this.isCollapsed = false;

      this.productMediaWrapper = this.querySelector('[data-product-media]');
      if (!this.productMediaWrapper.classList.contains('collapsible-gallery')) {
        return;
      }

      this.openTrigger = this.querySelector('[data-trigger-show-more]');
      this.closeTrigger = this.querySelector('[data-trigger-show-less]');

      this.openTrigger.addEventListener('click', this.expandContainer.bind(this));
      this.closeTrigger.addEventListener('click', this.collapseContainer.bind(this));
      window.addEventListener('resize', this.onResizeWindow.bind(this));

      this.calculateMinMaxHeight();
      this.setHeight(this.minHeight);
      this.listenParentPopup();
    }

    /**
     * If media is inside an popup which is a dialog wrapper all elements height will be 0.
     * So we need to calculate again on popup open.
     * @returns
     */
    listenParentPopup() {
      const popup = this.closest('popup-element');
      if (!popup) return;

      popup.addEventListener('popup-toggled', (ev) => {
        if (ev.detail.open) {
          this.init();
        }
      });
    }

    expandContainer() {
      this.productMediaWrapper.classList.add('collapsible-gallery--open');
      this.setHeight(this.maxHeight);
      this.isCollapsed = true;
    }

    collapseContainer() {
      this.productMediaWrapper.classList.remove('collapsible-gallery--open');
      this.setHeight(this.minHeight);
      this.isCollapsed = false;

      setTimeout(() => {
        this.openTrigger.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
      }, 300);
    }

    calculateMinMaxHeight() {
      this.gridMediaContainer = this.querySelector('[data-product-media-container]');

      const images = this.gridMediaContainer.children;
      const gap = parseInt(window.getComputedStyle(this.gridMediaContainer).gap);
      const imageHeight = images[0].offsetHeight;

      const gridGapMin = images.length / 2 > 3 ? gap * 2 : Math.ceil(images.length / 2) * gap - gap;
      const gridGapMax = parseInt(images.length / 2) * gap;

      this.minHeight = imageHeight * 3 + gridGapMin;
      this.maxHeight = imageHeight * Math.ceil(images.length / 2) + gridGapMax;
    }

    setHeight(maxHeight) {
      this.gridMediaContainer.style.maxHeight = `${maxHeight}px`;
    }

    onResizeWindow() {
      if (window.innerWidth > 768) {
        this.calculateMinMaxHeight();
        if (this.isCollapsed) {
          this.expandContainer();
        } else {
          this.collapseContainer();
        }
      }
    }
  }
  customElements.define('product-media-grid', ProductMediaGrid);
}
